import { render, staticRenderFns } from "./AuthModalForm.vue?vue&type=template&id=3a56e50c&scoped=true&"
import script from "./AuthModalForm.vue?vue&type=script&lang=js&"
export * from "./AuthModalForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthModalForm.vue?vue&type=style&index=0&id=3a56e50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56e50c",
  null
  
)

export default component.exports